<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <div
      class="mr-4"
      style="display: inline-block; cursor: pointer; color: #213a8f"
      @click="
        params.data.adCampaignBudget &&
        (params.data.adCampaignBudget.googleActive ||
          params.data.adCampaignBudget.facebookActive)
          ? duplicateVacancyActiveCampaign()
          : duplicateVacancy()
      "
    >
      <i class="far fa-clone" style="font-size: 17.5px"></i>
    </div>
    <router-link :to="editRoute">
      <feather-icon
        icon="pen"
        svg-classes="h-5 w-5 mr-4 hover:text-primary
      cursor-pointer"
        @click="
          params.data.adCampaignBudget &&
            (params.data.adCampaignBudget.googleActive ||
              params.data.adCampaignBudget.facebookActive) &&
            editVacancyActiveCampaign($event, editRoute)
        "
      />
    </router-link>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "CellRendererActions",
  computed: {
    editRoute() {
      return `/project/${this.params.data.project.id}/edit/jobs/${this.params.data.id}`;
    }
  },
  methods: {
    async duplicateVacancy() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Stelle duplizieren",
        text: `Du bist dabei, die aktuelle Stelle zu duplizieren.`,
        accept: async () => {
          this.duplicateVacancyRequest();
        },
        acceptText: "Ja",
        cancelText: "Nein"
      });
    },
    async duplicateVacancyActiveCampaign() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Stelle duplizieren",
        text: `Sie möchten eine Stelle duplizieren, welche derzeit für eine aktive Kampagne genutzt wird. Diese Aktion kann Auswirkungen auf die Kampagne haben. Möchten Sie dies durchführen?`,
        accept: async () => {
          this.duplicateVacancyRequest();
        },
        acceptText: "Ja",
        cancelText: "Nein"
      });
    },
    async duplicateVacancyRequest() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation VacancyDuplicate($vacancyDuplicateId: ID!) {
              vacancyDuplicate(id: $vacancyDuplicateId) {
                id
                project {
                  id
                }
              }
            }
          `,
          variables: {
            vacancyDuplicateId: this.params.data.id
          }
        })
        .then(res => {
          this.$router.push({
            name: "project.edit.sub.job",
            params: {
              id: res.data.vacancyDuplicate.project.id,
              page: "jobs",
              jobid: res.data.vacancyDuplicate.id,
              duplicated: true
            }
          });
        });
    },
    async editVacancyActiveCampaign(event, route) {
      event.preventDefault();
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Stelle bearbeiten",
        text: `Sie möchten eine Stelle bearbeiten, welche derzeit für eine aktive Kampagne genutzt wird. Diese Aktion kann Auswirkungen auf die Kampagne haben. Möchten Sie dies durchführen?`,
        accept: () => {
          this.$router.push(route);
        },
        acceptText: "Ja",
        cancelText: "Nein"
      });
    }
  }
};
</script>
